import React from 'react'
import { formatCurrency } from '../../../lib/utils/formatNumber'
import { Vehicle } from '../../../lib/types/Vehicle'
import { ImageGallery } from '@demandlocal/components'
import FallbackImage from './../../../images/fallback_car.png'
import cleanUrl from '../../../lib/utils/cleanURL'
import { useNavigate } from 'react-router-dom'
import dayjs from 'dayjs'
import { ADMIN_VENDOR_MAP, VENDOR } from '../../../lib/utils/vendors'
import { ReactComponent as GoogleIcon } from './../../../images/icons/audience_google.svg'
import { ReactComponent as FacebookIcon } from './../../../images/icons/audience_facebook.svg'
import { ReactComponent as TradeDeskIcon } from './../../../images/icons/audience_tradedesk.svg'
import { ReactComponent as BingIcon } from './../../../images/icons/audience_bing.svg'
import { useTranslation } from 'react-i18next'
import { useDealership } from '../../../store/zustand/dealershipStore'

const GridItemMarketedVehicle = ({ item }: { item: Vehicle }): JSX.Element => {
  const images = (item?.image_url?.match(/https:\/\/.*?(?=\|\|\|\||\|https|,https|;https|$)/) || []).map(cleanUrl)
  const { t } = useTranslation('routes')
  const navigate = useNavigate()
  const dealership = useDealership()
  return (
    <div
      className={'rounded-lg overflow-hidden cursor-pointer'}
      onClick={() =>
        navigate(
          t('dealership.vehicles.vehicle', {
            dealership,
            vehicle: {
              vin: item.vin_number,
            },
          }),
        )
      }>
      <div className={'h-[220px] '}>
        <ImageGallery
          fallbackImage={FallbackImage}
          key={item?.vin_number}
          images={images}
        />
      </div>
      <div className={'flex flex-col gap-3 bg-cultured-gray text-primary-xiketic p-5'}>
        <span className={'text-base font-bold '}>
          {item.year ?? ''} {item.make ?? ''} {item?.model ?? ''}
        </span>
        <div className={'flex flex-col font-medium text-xs gap-1 '}>
          <span>VIN: {item?.vin_number}</span>
          <span>Stock #: {item?.stock_number}</span>
        </div>
        <div className="flex flex-row justify-between font-bold items-center w-1/2">
          <div className="flex flex-row gap-2 items-center">
            <div className="w-5 h-5 rounded-full bg-gradient-to-b from-light-green to-vivid-sky-blue" />
            <span className="text-base text-xs">Impressions</span>
          </div>
          <span className="text-base text-xs">{item?.impressions}</span>
        </div>
        <div className="flex flex-row justify-between font-bold items-center w-1/2">
          <div className="flex flex-row gap-2 items-center">
            <div className="w-5 h-5 rounded-full bg-gradient-to-b from-melon to-cyclamen" />
            <span className="text-base text-xs">Clicks</span>
          </div>
          <span className="text-base text-xs">{item?.clicks}</span>
        </div>

        <div className="flex flex-row gap-2 items-cetner">
          <span className="text-base font-bold">Marketed on:</span>
          <div className="flex flex-row gap-2 items-center">
            {item.vendor_id
              ?.split(',')
              ?.sort((a, b) => Number(a) - Number(b))
              ?.map((id) => {
                return (
                  <div key={id}>
                    {ADMIN_VENDOR_MAP[Number(id)] === VENDOR.Google && <GoogleIcon />}
                    {ADMIN_VENDOR_MAP[Number(id)] === VENDOR.Facebook && <FacebookIcon />}
                    {[21, 26].includes(Number(id)) && <TradeDeskIcon />}
                    {[3].includes(Number(id)) && <BingIcon />}
                  </div>
                )
              })}
          </div>
        </div>
      </div>
    </div>
  )
}

export default GridItemMarketedVehicle
